export default __webpack_public_path__ + "static/media/p1.50202ea1.jpg";